import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './AccountDeactivation.css';
import { useContext } from "react";
import AlertContext from "../../../contexts/AlertContext";

const AccountDeactivation = ({ isDeactivated }) => {
  const [deactivationType, setDeactivationType] = useState('temporary');
  const [duration, setDuration] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const { showAlert } = useContext(AlertContext);

  const handleDeactivation = async () => {
    try {
      if (deactivationType === 'temporary') {
        if (!duration || parseInt(duration) < 1) {
          showAlert('Please provide a valid duration (in months)', "error");
          return;
        }

        const confirmTemp = window.confirm(
          `Are you sure you want to temporarily deactivate your account for ${duration} month(s)?`
        );
        if (!confirmTemp) return;

      } else if (deactivationType === 'permanent') {
        const confirmPermanent = window.confirm(
          '⚠️ This will permanently delete your account. Continue?'
        );
        if (!confirmPermanent) return;
      }

      const payload = {
        type: deactivationType,
        durationInMonths: deactivationType === 'temporary' ? duration : undefined,
      };

      await axios.post('https://back.varankal.com/auth/deactivate', payload, {
        withCredentials: true,
      });

      showAlert('Account deactivated successfully.');


    } catch (error) {
      console.error('Error during deactivation:', error);
      alert(error.response?.data?.message || 'An error occurred while deactivating your account.');
    }
  };

  return (
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <h2>Deactivate Account</h2>
      <div>
        <label>
          <input
            type="radio"
            name="deactivationType"
            value="temporary"
            checked={deactivationType === 'temporary'}
            onChange={() => setDeactivationType('temporary')}
          /> Temporary (hide for a few months)
        </label>
        <label>
          <input
            type="radio"
            name="deactivationType"
            value="permanent"
            checked={deactivationType === 'permanent'}
            onChange={() => setDeactivationType('permanent')}
          /> Permanent (remove forever)
        </label>
      </div>

      {deactivationType === 'temporary' && (
        <div>
          <label>
            Duration (months):
            <input
              type="number"
              min="1"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
            />
          </label>
        </div>
      )}

      {errorMessage && <p className="error">{errorMessage}</p>}

      <div className="modal-actions">
        {!isDeactivated && (
          <button onClick={handleDeactivation}>Deactivate Account</button>
        )}
      </div>
    </div>
  );
};

export default AccountDeactivation;
